export interface Theme {
  domain: string;
  name: string;
  colors: {
    primary: string;
    secondary: string;
    accent: string;
    // ... other colors
  };
  logoUrl: string;
  faviconUrl: string;
}

export const themes: Record<string, Theme> = {
  "farminsta.com": {
    domain: "farminsta.com",
    name: "Farminsta",
    colors: {
      primary: "142, 66%, 36%",
      secondary: "138, 40%, 52%",
      accent: "158, 48%, 96%",
    },
    logoUrl: "/images/logo/fi_lg.png",
    faviconUrl: "/images/logo/fi_sm.png",
  },
  "pandoforce.com": {
    domain: "pandoforce.com",
    name: "Pandoforce",
    colors: {
      primary: "180, 100%, 25%",
      secondary: "180, 52%, 42%",
      accent: "180, 67%, 96%",
    },
    logoUrl: "/images/logo/pf_lg.png",
    faviconUrl: "/images/logo/pf_sm.png",
  },
  "growthbook.farminsta.com": {
    domain: "growthbook.farminsta.com",
    name: "Shriram",
    colors: {
      primary: "206, 100%, 39%",
      secondary: "206, 52%, 60%",
      accent: "206, 67%, 96%",
    },
    logoUrl: "/images/logo/shriram-lg.png",
    faviconUrl: "/images/logo/shriram-sm.png",
  },
  default: {
    domain: "default",
    name: "Farminsta",
    colors: {
      primary: "142, 66%, 36%",
      secondary: "138, 40%, 52%",
      accent: "158, 48%, 96%",
    },
    logoUrl: "/images/logo/fi_lg.png",
    faviconUrl: "/images/logo/fi_sm.png",
  },
};

export const getThemeByHost = (host?: string | null): Theme => {
  if (!host) return themes.default;
  // Check for growthbook.farminsta.com first (more specific)
  if (host.includes("growthbook.farminsta.com"))
    return themes["growthbook.farminsta.com"];
  if (host.includes("farminsta.com")) return themes["farminsta.com"];
  if (host.includes("pandoforce.com")) return themes["pandoforce.com"];

  // For development on localhost, you might want a specific theme or the default
  // if (host.includes('localhost:3000')) return themes['growthbook.farminsta.com']; // For testing growthbook theme
  if (host.includes("localhost")) return themes["farminsta.com"]; // Or themes.default
  return themes.default;
};
